module.exports = __webpack_public_path__ + "static/img/case2.ab699205.jpg";